// extracted by mini-css-extract-plugin
export default {"resizer__horizontal":"Resizer_resizer__horizontal__UHNb3"};